import { useState, useCallback, useEffect } from 'react';
import { SelectItemProps, Account } from '@ui/src';
import { useLazyGetExchangeAccountsQuery } from '../services';

interface ListResponse {
  data: { data: { edges: { node: Account }[] } };
}

let timeout: NodeJS.Timeout;

const useGetAutocompleteList = () => {
  const [autocompleteList, setAutocompleteList] = useState<SelectItemProps[]>(
    [],
  );

  const [getList] = useLazyGetExchangeAccountsQuery();

  const getAutocompleteListAction = useCallback(async (query?: string) => {
    const results: SelectItemProps[] = [];

    const response = (await getList(
      `?take=40&closed=false&fullNumber=4.2.${query ? `&search=${query}` : ''}`,
    )) as ListResponse;

    if (response?.data?.data) {
      response.data.data.edges?.forEach((item) => {
        const result: SelectItemProps = {
          name: '',
          description: '',
          value: item.node.id,
        };

        if (item.node.clientName && item.node.fullNumber) {
          result.name = item.node.description;
          result.description = item.node.clientName;
          result.suffix = item.node.fullNumber;
        } else if (!item.node.clientName) {
          result.name = item.node.fullNumber;
        }

        results.push(result);
      });
    }

    setAutocompleteList(results);
  }, []);

  const onSearch = (query: string) => {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      getAutocompleteListAction(query);
    }, 500);
  };

  useEffect(() => {
    getAutocompleteListAction();
  }, [getAutocompleteListAction]);

  return {
    getAutocompleteListAction,
    accounts: autocompleteList,
    onSearch,
  };
};

export default useGetAutocompleteList;
